import { SortOrder } from '@Utils/helpers/sortingHelpers';
import _orderBy from 'lodash/orderBy';
import { IProject, ViewProjectSortField } from './Interfaces';

export function getSortedProjects(
    projects: Array<IProject>,
    sortOrder: SortOrder,
    sortByField: ViewProjectSortField
): Array<IProject> {
    const sortOrderStr = sortOrder === SortOrder.ASC ? 'asc' : 'desc';
    const getDate = (p: IProject) => {
        return new Date(p.last_modified);
    };
    switch (sortByField) {
        case ViewProjectSortField.CREATED:
            return _orderBy(projects, ['project_id'], [sortOrderStr]);
        case ViewProjectSortField.NAME:
            return _orderBy(
                projects,
                (p) => p.project_name.toLowerCase(),
                sortOrderStr
            );
        case ViewProjectSortField.LAST_MODIFIED:
            return _orderBy(projects, [getDate], [sortOrderStr]);
    }
}
